import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query'
import { WalletConfigFilterKey, WalletConfigKey } from 'api/Wallet/Types/WalletConfigDto'
import { BuildQueryProps } from 'utils/QueryHelpers'

export const normalizeWalletsSearchQuery = (
  filterDescriptor: FilterDescriptor[] | CompositeFilterDescriptor
): BuildQueryProps => {
  const gridFilterDescriptor = filterDescriptor as CompositeFilterDescriptor
  const filters =
    gridFilterDescriptor?.filters.map((x: FilterDescriptor | CompositeFilterDescriptor) => {
      const filterItem = x as FilterDescriptor

      if (filterItem.field === WalletConfigKey.tickmillCompany) {
        return {
          ...filterItem,
          field: WalletConfigFilterKey.tickmillCompany,
          value: filterItem?.value,
        }
      }
      if (filterItem.field === WalletConfigKey.country) {
        return {
          ...filterItem,
          field: WalletConfigFilterKey.country,
          value: filterItem?.value,
        }
      }
      if (filterItem.field === WalletConfigKey.walletType) {
        return {
          ...filterItem,
          field: WalletConfigFilterKey.walletType,
          value: filterItem?.value,
        }
      }
      if (filterItem.field === WalletConfigKey.currency) {
        return {
          ...filterItem,
          field: WalletConfigFilterKey.currency,
          value: filterItem?.value,
        }
      }
      if (filterItem.field === WalletConfigKey.isDefault) {
        return {
          ...filterItem,
          field: WalletConfigFilterKey.isDefault,
          value: filterItem?.value,
        }
      }
      if (filterItem.field === WalletConfigKey.isInternal) {
        return {
          ...filterItem,
          field: WalletConfigFilterKey.isInternal,
          value: filterItem?.value,
        }
      }

      return filterItem
    }) || []

  return { ...gridFilterDescriptor, filters }
}
